import React, { Component } from "react";
import firebase from "firebase";
import { connect } from "react-redux";

import {
  Form,
  Image,
  InputGroup,
  FormControl,
  Button,
  Spinner,
} from "react-bootstrap";
import TextareaAutosize from "react-textarea-autosize";
import AvatarEditor from "react-avatar-editor";

import "./Left.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLock,
  faLockOpen,
  faCamera,
  faCheck,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { postData } from "../../utils/index";
import { API_BASE_URL, ROOM_CREATE } from "../../config/index";
import { setCurrentWorkspace, setWorkspaces } from "../../actions/index";
import _ from "lodash";

const DEFAULT_AVATAR =
  "PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjEuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxMjAgMTIwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMjAgMTIwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6I0NDQ0NDQztzdHJva2U6I0NDQ0NDQztzdHJva2UtbWl0ZXJsaW1pdDoxMDt9Cgkuc3Qxe2NsaXAtcGF0aDp1cmwoI1NWR0lEXzJfKTt9Cgkuc3Qye2NsaXAtcGF0aDp1cmwoI1NWR0lEXzRfKTt9Cgkuc3Qze2ZpbGw6I0ZGRkZGRjt9Cgkuc3Q0e2NsaXAtcGF0aDp1cmwoI1NWR0lEXzZfKTt9Cgkuc3Q1e2NsaXAtcGF0aDp1cmwoI1NWR0lEXzhfKTt9Cgkuc3Q2e2NsaXAtcGF0aDp1cmwoI1NWR0lEXzEwXyk7fQoJLnN0N3tjbGlwLXBhdGg6dXJsKCNTVkdJRF8xMl8pO30KCS5zdDh7Y2xpcC1wYXRoOnVybCgjU1ZHSURfMTRfKTt9Cjwvc3R5bGU+CjxlbGxpcHNlIGNsYXNzPSJzdDAiIGN4PSI2MCIgY3k9IjYwIiByeD0iNTguNSIgcnk9IjU4LjUiLz4KPGc+Cgk8ZGVmcz4KCQk8ZWxsaXBzZSBpZD0iU1ZHSURfMV8iIGN4PSI2MCIgY3k9IjYwIiByeD0iNTgiIHJ5PSI1OCIvPgoJPC9kZWZzPgoJPGNsaXBQYXRoIGlkPSJTVkdJRF8yXyI+CgkJPHVzZSB4bGluazpocmVmPSIjU1ZHSURfMV8iICBzdHlsZT0ib3ZlcmZsb3c6dmlzaWJsZTsiLz4KCTwvY2xpcFBhdGg+Cgk8ZyBjbGFzcz0ic3QxIj4KCQk8Zz4KCQkJPGRlZnM+CgkJCQk8Y2lyY2xlIGlkPSJTVkdJRF8zXyIgY3g9IjYwIiBjeT0iNjAiIHI9IjU5Ii8+CgkJCTwvZGVmcz4KCQkJPGNsaXBQYXRoIGlkPSJTVkdJRF80XyI+CgkJCQk8dXNlIHhsaW5rOmhyZWY9IiNTVkdJRF8zXyIgIHN0eWxlPSJvdmVyZmxvdzp2aXNpYmxlOyIvPgoJCQk8L2NsaXBQYXRoPgoJCQk8ZyBjbGFzcz0ic3QyIj4KCQkJCTxnPgoJCQkJCTxwYXRoIGNsYXNzPSJzdDMiIGQ9Ik0xMDEuOCw3Mi41aC05LjJjMC45LDIuNiwxLjQsNS4zLDEuNCw4LjJ2MzQuN2MwLDEuMi0wLjIsMi40LTAuNiwzLjRoMTUuMmM1LjcsMCwxMC4zLTQuNiwxMC4zLTEwLjNWODkuNgoJCQkJCQlDMTE5LDgwLjIsMTExLjMsNzIuNSwxMDEuOCw3Mi41eiIvPgoJCQkJPC9nPgoJCQk8L2c+CgkJPC9nPgoJCTxnPgoJCQk8ZGVmcz4KCQkJCTxjaXJjbGUgaWQ9IlNWR0lEXzVfIiBjeD0iNjAiIGN5PSI2MCIgcj0iNTkiLz4KCQkJPC9kZWZzPgoJCQk8Y2xpcFBhdGggaWQ9IlNWR0lEXzZfIj4KCQkJCTx1c2UgeGxpbms6aHJlZj0iI1NWR0lEXzVfIiAgc3R5bGU9Im92ZXJmbG93OnZpc2libGU7Ii8+CgkJCTwvY2xpcFBhdGg+CgkJCTxnIGNsYXNzPSJzdDQiPgoJCQkJPGc+CgkJCQkJPHBhdGggY2xhc3M9InN0MyIgZD0iTTI1LDgwLjdjMC0yLjksMC41LTUuNywxLjUtOC4yaC05LjJjLTkuNSwwLTE3LjIsNy43LTE3LjIsMTcuMnYxOC45YzAsNS43LDQuNiwxMC4zLDEwLjMsMTAuM2gxNS4yCgkJCQkJCWMtMC40LTEuMS0wLjYtMi4yLTAuNi0zLjRDMjUuMSwxMTUuNCwyNS4xLDgwLjcsMjUsODAuN3oiLz4KCQkJCTwvZz4KCQkJPC9nPgoJCTwvZz4KCQk8Zz4KCQkJPGRlZnM+CgkJCQk8Y2lyY2xlIGlkPSJTVkdJRF83XyIgY3g9IjYwIiBjeT0iNjAiIHI9IjU5Ii8+CgkJCTwvZGVmcz4KCQkJPGNsaXBQYXRoIGlkPSJTVkdJRF84XyI+CgkJCQk8dXNlIHhsaW5rOmhyZWY9IiNTVkdJRF83XyIgIHN0eWxlPSJvdmVyZmxvdzp2aXNpYmxlOyIvPgoJCQk8L2NsaXBQYXRoPgoJCQk8ZyBjbGFzcz0ic3Q1Ij4KCQkJCTxnPgoJCQkJCTxwYXRoIGNsYXNzPSJzdDMiIGQ9Ik03MC4xLDYzLjVoLTIxYy05LjUsMC0xNy4yLDcuNy0xNy4yLDE3LjJ2MzQuN2MwLDEuOSwxLjUsMy40LDMuNCwzLjRoNDguNWMxLjksMCwzLjQtMS41LDMuNC0zLjRWODAuNwoJCQkJCQlDODcuMiw3MS4yLDc5LjUsNjMuNSw3MC4xLDYzLjV6Ii8+CgkJCQk8L2c+CgkJCTwvZz4KCQk8L2c+CgkJPGc+CgkJCTxkZWZzPgoJCQkJPGNpcmNsZSBpZD0iU1ZHSURfOV8iIGN4PSI2MCIgY3k9IjYwIiByPSI1OSIvPgoJCQk8L2RlZnM+CgkJCTxjbGlwUGF0aCBpZD0iU1ZHSURfMTBfIj4KCQkJCTx1c2UgeGxpbms6aHJlZj0iI1NWR0lEXzlfIiAgc3R5bGU9Im92ZXJmbG93OnZpc2libGU7Ii8+CgkJCTwvY2xpcFBhdGg+CgkJCTxnIGNsYXNzPSJzdDYiPgoJCQkJPGc+CgkJCQkJPHBhdGggY2xhc3M9InN0MyIgZD0iTTU5LjYsMThjLTExLjQsMC0yMC42LDkuMy0yMC42LDIwLjZjMCw3LjcsNC4zLDE0LjUsMTAuNSwxOGMzLDEuNyw2LjQsMi42LDEwLjEsMi42YzMuNywwLDcuMS0xLDEwLjEtMi42CgkJCQkJCWM2LjMtMy41LDEwLjYtMTAuMywxMC42LTE4QzgwLjIsMjcuMyw3MC45LDE4LDU5LjYsMTh6Ii8+CgkJCQk8L2c+CgkJCTwvZz4KCQk8L2c+CgkJPGc+CgkJCTxkZWZzPgoJCQkJPGNpcmNsZSBpZD0iU1ZHSURfMTFfIiBjeD0iNjAiIGN5PSI2MCIgcj0iNTkiLz4KCQkJPC9kZWZzPgoJCQk8Y2xpcFBhdGggaWQ9IlNWR0lEXzEyXyI+CgkJCQk8dXNlIHhsaW5rOmhyZWY9IiNTVkdJRF8xMV8iICBzdHlsZT0ib3ZlcmZsb3c6dmlzaWJsZTsiLz4KCQkJPC9jbGlwUGF0aD4KCQkJPGcgY2xhc3M9InN0NyI+CgkJCQk8Zz4KCQkJCQk8cGF0aCBjbGFzcz0ic3QzIiBkPSJNMjMuMywzNy4zYy04LjUsMC0xNS40LDYuOS0xNS40LDE1LjRzNi45LDE1LjQsMTUuNCwxNS40YzIuMiwwLDQuMi0wLjQsNi4xLTEuMmMzLjItMS40LDUuOS0zLjgsNy41LTYuOQoJCQkJCQljMS4yLTIuMiwxLjgtNC42LDEuOC03LjJDMzguOCw0NC4yLDMxLjksMzcuMywyMy4zLDM3LjN6Ii8+CgkJCQk8L2c+CgkJCTwvZz4KCQk8L2c+CgkJPGc+CgkJCTxkZWZzPgoJCQkJPGNpcmNsZSBpZD0iU1ZHSURfMTNfIiBjeD0iNjAiIGN5PSI2MCIgcj0iNTkiLz4KCQkJPC9kZWZzPgoJCQk8Y2xpcFBhdGggaWQ9IlNWR0lEXzE0XyI+CgkJCQk8dXNlIHhsaW5rOmhyZWY9IiNTVkdJRF8xM18iICBzdHlsZT0ib3ZlcmZsb3c6dmlzaWJsZTsiLz4KCQkJPC9jbGlwUGF0aD4KCQkJPGcgY2xhc3M9InN0OCI+CgkJCQk8Zz4KCQkJCQk8cGF0aCBjbGFzcz0ic3QzIiBkPSJNOTUuOCwzNy4zYy04LjUsMC0xNS40LDYuOS0xNS40LDE1LjRjMCwyLjYsMC43LDUuMSwxLjgsNy4yYzEuNywzLjEsNC4zLDUuNSw3LjUsNi45CgkJCQkJCWMxLjksMC44LDMuOSwxLjIsNi4xLDEuMmM4LjUsMCwxNS40LTYuOSwxNS40LTE1LjRTMTA0LjMsMzcuMyw5NS44LDM3LjN6Ii8+CgkJCQk8L2c+CgkJCTwvZz4KCQk8L2c+Cgk8L2c+CjwvZz4KPC9zdmc+Cg==";

export class AddARoom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      channelUsers: [],
      users: [],
      channelName: "",
      channelDetails: "",
      channelsRef: firebase.database().ref("channels"),

      searchParticipant: "",
      searchResultsParticipants: false,

      previewImage: "",
      avatar: null,
      metadata: {},
      cropImage: false,
      croppedImage: "",
      uploadedAvatar: "",
      storageRef: firebase.storage().ref(),

      workspace_id: this.props.currentWorkspace.workspaceId,
      user_id: "",
      room_name: "",
      room_description: "",
      video_server_location: "ap-south-1.igesia.com",
      room_type: false,
      room_pic: DEFAULT_AVATAR,
      room_pic_name: `default-room.png`,
      room_pic_mime: "image/svg+xml",
      isLoading: false,

      error: "",
    };
  }

  componentDidMount() {
    const { currentUser, currentWorkspace } = this.props;

    this._handleStateChange("user_id", currentUser.uid);
    this._handleStateChange(
      "workspace_id",
      this.props.currentWorkspace.workspaceId
    );
  }

  componentDidUpdate() {
    if (this.state.workspace_id !== this.props.currentWorkspace.workspaceId) {
      this._handleStateChange(
        "workspace_id",
        this.props.currentWorkspace.workspaceId
      );
    }
  }

  _handleStateChange = (attr, val) => this.setState({ [attr]: val });

  handleChange = (event) => {
    if (event.target.name !== "channelUsers[]")
      this.setState({ [event.target.name]: event.target.value });
    else
      this.setState({
        channelUsers: this.state.channelUsers.includes(event.target.value)
          ? this.state.channelUsers.filter((a) => a != event.target.value)
          : [...this.state.channelUsers, event.target.value],
      });
  };

  handleSearchParticipant = (event) => {
    this.setState(
      {
        searchParticipant: event.target.value,
        searchParticipantLoading: true,
      },
      () => {
        const users = [...this.state.users];
        const regex = new RegExp(this.state.searchParticipant, "gi");
        const searchResultsParticipants = users.reduce((acc, user) => {
          if (user.name && user.name.match(regex)) {
            acc.push(user);
          }
          return acc;
        }, []);
        this.setState({ searchResultsParticipants });
        setTimeout(
          () => this.setState({ searchParticipantLoading: false }),
          1000
        );
      }
    );
  };

  handleSubmit = (event) => {
    if (this.isFormValid(this.state)) {
      this.addChannel();
    }
  };

  isFormValid = ({ channelName, channelUsers }) => channelName && channelUsers;

  addChannel = () => {
    const {
      channelsRef,
      channelName,
      channelDetails,
      channelUsers,
      uploadedAvatar,
    } = this.state;
    const { currentUser } = this.props;

    const key = channelsRef.push().key;

    const users = [];
    channelUsers.map((item) => (users[item] = { admin: false }));
    users[currentUser.uid] = { admin: true };

    const { storageRef, avatar, metadata } = this.state;

    if (avatar !== null && avatar !== "") {
      storageRef
        .child(`avatars/rooms/${key}`)
        .put(avatar, metadata)
        .then((snap) => {
          snap.ref.getDownloadURL().then((downloadURL) => {
            this.setState({ uploadedAvatar: downloadURL });
            const newChannel = {
              id: key,
              avatar: downloadURL,
              name: channelName,
              details: channelDetails,
              createdBy: {
                name: currentUser.displayName,
                avatar: currentUser.photoURL,
                uid: currentUser.uid,
              },
              admin: currentUser.uid,
              users: { ...users },
            };

            channelsRef
              .child(key)
              .update(newChannel)
              .then(() => {
                this.setState({
                  channelUsers: [],
                  users: [],
                  channelName: "",
                  channelDetails: "",
                  previewImage: "",
                  avatar: null,
                  uploadedAvatar: "",
                });
                console.log("channel added");
              })
              .catch((err) => {
                console.error(err);
              });
            console.log(newChannel);
          });
        });
    } else {
      const newChannel = {
        id: key,
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/avatars%2Fusers%2Fgroup-icon.svg?alt=media&token=fb8447a2-3564-4fe7-bf57-c7452f9c5baa",
        name: channelName,
        details: channelDetails,
        createdBy: {
          name: currentUser.displayName,
          avatar: currentUser.photoURL,
          uid: currentUser.uid,
        },
        admin: currentUser.uid,
        users: { ...users },
      };

      channelsRef
        .child(key)
        .update(newChannel)
        .then(() => {
          this.setState({
            channelUsers: [],
            users: [],
            channelName: "",
            channelDetails: "",
            previewImage: "",
            avatar: null,
            uploadedAvatar: "",
          });
          console.log("channel added");
        })
        .catch((err) => {
          console.error(err);
        });
      console.log(newChannel);
    }
  };

  handleChangeFile = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    if (file) {
      let metadata = {
        contentType: file.type,
      };

      reader.readAsDataURL(file);
      reader.addEventListener("load", () => {
        this.setState({
          previewImage: reader.result,
          metadata,
          cropImage: true,
          room_pic: "",
          room_pic_mime: file.type,
          room_pic_name: file.name,
        });
      });
    }
  };

  handleCropImage = () => {
    if (this.avatarEditor) {
      this.avatarEditor.getImageScaledToCanvas().toBlob((blob) => {
        let reader = new FileReader();
        reader.readAsDataURL(blob);

        reader.addEventListener("load", () => {
          this.setState({
            room_pic: reader.result.split("base64,")[1],
          });
        });

        let imageUrl = URL.createObjectURL(blob);
        this.setState({
          croppedImage: imageUrl,
          avatar: blob,
          cropImage: false,
          error: "",
        });
      });
    }
  };

  _handleCreateRoom = () => {
    const {
      workspace_id,
      user_id,
      room_name,
      room_description,
      room_type,
      video_server_location,
      room_pic,
      room_pic_name,
      room_pic_mime,

      cropImage,
    } = this.state;

    let roomData = {
      workspace_id,
      user_id,
      room_name,
      room_type: room_type ? "1" : "0",
      video_server_location,
      room_pic,
      room_pic_name,
      room_pic_mime,
    };

    if (room_description != "") {
      roomData["room_description"] = room_description;
    }
    if (room_name.replace(/\s/g, "").length === 0) {
      this.setState({
        error: "Please enter valid room name.",
      });
      return;
    }

    if (cropImage) {
      this.setState({ error: "Please complete crop image process." });
      return;
    }

    if (room_pic === "") {
      this.setState({ error: "Please provide image." });
      return;
    }

    this.setState({ isLoading: true });

    console.log("Room data: ", roomData);

    postData(`${API_BASE_URL}${ROOM_CREATE}`, roomData)
      .then((response) => {
        console.log(response);
        const { message, status } = response;
        if (status === 400) {
          alert(message);
        }
        if (status === 200) {
          this.displayData = [];
          this.props.toggleRooms();

          firebase
            .firestore()
            .collection(`users/${this.props.currentUser.uid}/rooms`)
            .get()
            .then((querySnapshot) => {
              let userWorkspaces = [];
              querySnapshot.docs.forEach(function (doc) {
                userWorkspaces.push({ ...doc.data() });
              });

              let index;

              userWorkspaces.forEach((workspace, key) => {
                if (
                  workspace.workspaceId ===
                  this.props.currentWorkspace?.workspaceId
                ) {
                  console.log(key, "key in userworkspaces");
                  index = key;
                }
              });

              const updatedCurrentWorkspace = {
                ...this.props.currentWorkspace,
                ...userWorkspaces[index],
              };
              this.props.setCurrentWorkspace(
                _.cloneDeep(updatedCurrentWorkspace)
              );
              this.props.setWorkspaces(this.props.currentUser.uid);
            })
            .then(() => {
              alert("Room created successfully.");
              this._handleStateReset();
            });
        }
        this.setState({ isLoading: false });
      })
      .catch((error) => console.error(error));
  };

  _handleStateReset = () => {
    const { currentUser } = this.props;

    this.setState({
      workspace_id: this.props.currentWorkspace.workspaceId,
      user_id: `${currentUser.uid}`,
      room_name: "",
      room_description: "",
      video_server_location: "ap-south-1.igesia.com",
      room_type: false,
      room_pic: DEFAULT_AVATAR,
      room_pic_name: `${Date.now()}`,
      room_pic_mime: "image/svg+xml",
      isLoading: false,
      previewImage: "",
      avatar: null,
      metadata: {},
      cropImage: false,
      croppedImage: "",
      uploadedAvatar: "",
    });
  };

  render() {
    const {
      workspace_id,
      user_id,
      room_name,
      room_description,
      room_pic,
      room_type,
      video_server_location,
      room_pic_name,
      room_pic_mime,
      isLoading,
    } = this.state;
    const { currentWorkspace, currentUser } = this.props;

    return (
      <div className="px-3">
        {/* <div className="d-flex align-items-center p-2 w-100">
                    <img
                        className="mr-2 bg-light rounded-circle"
                        src={currentWorkspace.workspacePic}
                        style={{ height: 40, width: 40 }} />

                    <div className="flex-grow-1">
                        <p className="text-white m-0 h6">{currentWorkspace.workspaceName}</p>
                        <small className="text-theme m-0">Workspace</small>
                    </div>
                </div> */}
        <Form className="mb-3">
          {this.state.cropImage ? (
            <div className="d-flex flex-column my-2">
              <p className="small text-muted text-center mb-1">CROP IMAGE</p>
              <div className="d-flex justify-content-center align-items-center">
                <AvatarEditor
                  ref={(node) => (this.avatarEditor = node)}
                  image={this.state.previewImage}
                  width={150}
                  height={150}
                />
              </div>
              <div className="d-flex justify-content-center align-items-center">
                <Button
                  variant="light"
                  size="sm"
                  className="d-flex justify-content-center align-items-center text-success"
                  onClick={this.handleCropImage}
                >
                  <FontAwesomeIcon className="mr-2" icon={faCheck} /> Done
                </Button>
                <Button
                  variant="light"
                  size="sm"
                  className="d-flex justify-content-center align-items-center text-secondary"
                  onClick={() =>
                    this.setState({
                      cropImage: false,
                      room_pic: DEFAULT_AVATAR,
                      room_pic_name: `${Date.now()}`,
                      room_pic_mime: "image/svg+xml",
                    })
                  }
                >
                  <FontAwesomeIcon className="mr-2" icon={faTimes} /> Cancel
                </Button>
              </div>
            </div>
          ) : (
            <div className="my-5 mx-auto" id="add-avatar">
              <label for="avatar">
                <Image
                  id="avatar-image"
                  width="150"
                  height="150"
                  roundedCircle
                  // src={this.state.croppedImage
                  //     ? `data:${room_pic_mime};base64,${room_pic}`
                  //     : "https://firebasestorage.googleapis.com/v0/b/igesia-web.appspot.com/o/avatars%2Fusers%2Fgroup-icon.svg?alt=media&token=fb8447a2-3564-4fe7-bf57-c7452f9c5baa"}
                  src={`data:${room_pic_mime};base64,${room_pic}`}
                  style={{ background: "#AEAEAE" }}
                />
              </label>
              <input
                type="file"
                id="avatar"
                accept="image/png, image/jpeg, image/jpg"
                onChange={this.handleChangeFile}
              />

              <label for="avatar" id="overlay">
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <FontAwesomeIcon icon={faCamera} className="text-white" />
                  <small className="text-white text-center px-2">
                    ADD ROOM ICON
                  </small>
                </div>
              </label>
            </div>
          )}

          <Form.Group>
            <Form.Control
              type="hidden"
              placeholder="Enter workspace id"
              value={this.props.currentWorkspace.workspaceId}
              onChange={(e) =>
                this._handleStateChange("workspace_id", e.target.value)
              }
            />
          </Form.Group>

          <Form.Group>
            <Form.Control
              type="hidden"
              placeholder="Enter user id"
              value={user_id}
              onChange={(e) =>
                this._handleStateChange("user_id", e.target.value)
              }
            />
          </Form.Group>

          <Form.Group>
            <div className="d-flex justify-content-between">
              <Form.Label>Room name</Form.Label>
              <div className="text-secondary small">
                {150 - room_name.length}
              </div>
            </div>
            <Form.Control
              maxLength="150"
              type="text"
              placeholder="Enter room name"
              value={room_name}
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  event.preventDefault();
                  document.getElementById("room-description").focus();
                }
              }}
              onChange={(e) =>
                this._handleStateChange("room_name", e.target.value)
              }
            />
          </Form.Group>

          <Form.Group>
            <div className="d-flex justify-content-between">
              <Form.Label>Room Description</Form.Label>
              <div className="text-secondary small">
                {2500 - room_description.length}
              </div>
            </div>
            <Form.Control
              id="room-description"
              as="textarea"
              maxLength="2500"
              type="text"
              placeholder="Enter room description"
              value={room_description}
              onChange={(e) =>
                this._handleStateChange("room_description", e.target.value)
              }
            />
          </Form.Group>

          {/*<Form.Group>
                        <Form.Label>Video server location</Form.Label>
                        <Form.Control
                            as="select"
                            onChange={e => this._handleStateChange("video_server_location", e.target.value)}
                        >
                            <option value="ap-south-1.igesia.com" selected={video_server_location === "ap-south-1.igesia.com" ? true : false}>South Asia</option>
                            <option value="us-east-2.igesia.com" selected={video_server_location === "us-east-2.igesia.com" ? true : false}>North America</option>
                            <option value="sa-east-1.igesia.com" selected={video_server_location === "sa-east-1.igesia.com" ? true : false}>South America</option>
                            <option value="eu-central-1.igesia.com" selected={video_server_location === "eu-central-1.igesia.com" ? true : false}>Europe</option>
                        </Form.Control>
                    </Form.Group>*/}

          <Form.Group>
            <Form.Label>Want to keep this room private?</Form.Label>
            <div className="d-flex align-items-center">
              <Form.Check
                type="switch"
                id="room_type"
                className="flex-grow-1"
                label={room_type ? "Private" : "Public"}
                value={room_type}
                checked={room_type}
                onChange={(e) =>
                  this._handleStateChange("room_type", !room_type)
                }
              />
              <FontAwesomeIcon
                icon={room_type ? faLock : faLockOpen}
                className={room_type ? "text-success" : "text-theme"}
                size="sm"
              />
            </div>
          </Form.Group>

          {this.state.error != "" ? (
            <p className="text-danger small">{this.state.error}</p>
          ) : null}

          {console.log(this.props.can_create, "can create")}
          <Button
            className="mr-2"
            size="sm"
            color="red"
            onClick={() => {
              // this.handleSubmit();
              // this.props.toggleRooms();
              this._handleCreateRoom();
            }}
            disabled={
              isLoading || this.props.roomLoading || !this.props.can_create
            }
          >
            {isLoading && (
              <Spinner
                as="span"
                role="status"
                aria-hidden="true"
                animation="border"
                className="mr-1"
                size="sm"
              />
            )}
            <span>Add</span>
          </Button>

          <Button
            className="mr-2"
            size="sm"
            color="red"
            onClick={() => {
              this.displayData = [];
              this.props.toggleRooms();
              this.props.setLeftActionType("");
              this._handleStateReset();
            }}
          >
            Cancel
          </Button>

          <br />

          {this.props.can_create ? null : (
            <p className="text-white mt-3">
              <b>Note: </b>
              You have already created maximum number of rooms allowed. To
              create more please write to us at{" "}
              <a target="_blank" href="mailto:hello@igesia.co">
                hello@igesia.co
              </a>
            </p>
          )}
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  currentWorkspace: state.workspace.currentWorkspace,
});

export default connect(mapStateToProps, {
  setCurrentWorkspace,
  setWorkspaces,
})(AddARoom);
